<template>
    <div>
        <app-nav></app-nav>
        <app-about id="omne"></app-about>
        <div class="space"></div>
        <app-grid id="portfolio"></app-grid>
        <div class="space"></div>
        <div class="imgUnderGrid"></div>
        <div class="space"></div>
        <app-price id="cenik"></app-price>
        <div class="space"></div>
        <div class="imgUnderPrice"></div>
        <div class="space"></div>
        <div class="container">
            <app-reference id="reference"></app-reference>
        </div>
        <div class="space"></div>
        <div id="kontakt" class="footerBlack">
            <div class="container pt-lg-5 pt-sm-4 pt-4">
                <h1 class="backgroundWhite">Kontakt</h1>

                <div id="icons" class="row pt-lg-5">
                    <div class="col-lg-3 text-center">
                        <img class="phone" src="../assets/phone.svg" alt="Phone">
                        <p class="iconSource pt-lg-4">+ 420 774 852 841</p>
                    </div>
                    <div class="col-lg-3 text-center">
                        <img class="mail" src="../assets/mail.svg" alt="Mail">
                        <p class="iconSource pt-lg-4"><a href="mailto:niki.we@seznam.cz">niki.we@seznam.cz</a></p>
                    </div>
                    <div class="col-lg-3 text-center">
                        <img class="facebook" src="../assets/facebook.svg" alt="Facebook">
                        <p class="iconSource pt-lg-4"><a href="https://www.facebook.com/NikolWetterovaphotography/">@NikolWetterovaphotography</a></p>
                    </div>
                    <div class="col-lg-3 text-center">
                        <img class="instagram" src="../assets/instagram.svg" alt="Instagram">
                        <p class="iconSource pt-lg-4"><a href="https://www.instagram.com/nikiwett_photography/?hl=cs">nikiwett_photography</a></p>
                    </div>
                </div>
                <footer class="pt-lg-4">
                    <div class="footer-copyright text-center py-3">© 2020 Copyright:
                        <a href="https://dokamar.cz/">Dokamar</a>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import NavTop from "./NavTop";
    import aboutUs from "./aboutUs";
    import gridPhoto from "./gridPhoto";
    import price from "./price";
    import reference from "./reference";

    export default {
        name: "homePage",
        components: {
            'app-grid': gridPhoto,
            'app-nav': NavTop,
            'app-about': aboutUs,
            'app-price': price,
            'app-reference': reference
        },
        data() {
            return {

            }

        }
    }
</script>

<style scoped>
    .space {
        padding-top: 10vh;
    }

    .imgUnderGrid {
        background-image: url("../assets/underPortfo.jpg");
        background-attachment: fixed;
        background-repeat: no-repeat;
        height: 50vh;
        background-size: cover;
    }
    .imgUnderPrice {
        background-image: url("../assets/underPrice.jpg");
        background-attachment: fixed;
        background-repeat: no-repeat;
        height: 50vh;
        background-size: cover;
    }
    @media screen and (max-width: 700px){
        .imgUnderGrid {
            background-attachment: inherit;
            background-position: 0;
        }
        .imgUnderPrice {
            background-attachment: inherit;
            background-position: 0;
        }
    }
    .footer-copyright {
        color: white;
    }
    .footerBlack {
        background-color: black;
    }

    h1 {
        padding-bottom: 0.5rem;
        padding-left: 15px;
        color: black;
        padding-top: 10px;
        font-size: 3rem;
    }

    .backgroundWhite {
        background-color: white;
    }
    #icons .phone, .mail, .facebook, .instagram{
        width: 20%;
    }
    .iconSource {
        color: white;
        font-family: "Lucida Grande";
    }
    a {
        color: white;
    }
    a:hover .iconSource {
        color: #007bff;
    }
    .kontaktText {
        color: white;
    }
    @media screen and (max-width: 991px){
        .phone {
            padding-top: 10px;
        }
        .mail {
            padding-top: 10px;
        }
        .facebook {
            padding-top: 10px;
        }
        .instagram {
            padding-top: 10px;
        }
    }
</style>